import styled, { css } from "styled-components/macro";
import { DefaultFont } from "../../../styles/fonts";

export const Root = styled.div`
  flex-shrink: 1;
  overflow-y: auto;
  position: relative;
`;

export const ChatItemContainer = styled.div``;
export const ChatDelimiter = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin: 0 8px;
`;

export const NoChats = styled.div`
  ${DefaultFont};
  color: ${(p) => p.theme.colors.chatTextColor};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  text-align: center;
`;

export const ChatItemRoot = styled.div<{ isSelected: boolean }>`
  padding: 16px;
  display: flex;
  cursor: pointer;
  border-radius: 8px;

  ${(p) =>
    p.isSelected
      ? css`
          background-color: ${(p) => p.theme.colors.bgSoftGray};
        `
      : ""};
`;

export const FullName = styled.div`
  ${DefaultFont};
  font-size: 16px;
  color: ${(p) => p.theme.colors.chatTextColor};
  font-weight: ${(p) => p.theme.font.weightMedium};
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const LastMessage = styled.div`
  color: ${(p) => p.theme.colors.textMuted};
  font-weight: ${(p) => p.theme.font.weightMedium};
  margin-bottom: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
`;

export const Time = styled.div`
  font-family: ${({ theme }) => theme.text.family};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 14px;
`;

export const ProfilePicture = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 48px;
  margin-right: 16px;
`;

export const RightSide = styled.div`
  flex-grow: 1;
  overflow: hidden;
  margin-right: 8px;
`;

export const NotificationsBox = styled.div`
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UnreadIndicator = styled.div`
  font-family: ${({ theme }) => theme.text.family};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
  background: ${(p) => p.theme.colors.text};
  font-weight: ${(p) => p.theme.font.weightMedium};
  min-width: 17px;
  border-radius: 12px;
  padding: 2px 3px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${(props) => props.theme.media.phone} {
    font-weight: ${({ theme }) => theme.text.default.mobileWeight};
  }
`;

export const LoaderContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
